import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import InputSelect from '../../commons/form/InputSelect'
import IDocCarPagination from '../../commons/iDocCarPagination'
import TemplatesModalPage from '../../../containers/masters/templates/TemplatesModalPage'
import MapSectionsMasters from '../../../util/map-sections-masters'

class Templates extends PureComponent {
  constructor () {
    super()
    this.state = {
      templateTypeId: null
    }
  }

  onTemplateTypeChange (templateTypeId) {
    if (templateTypeId !== this.state.templateTypeId) {
      this.setState({ templateTypeId })
      this.props.actions.fetchTemplateList({ ...this.props.filter, templateTypeId })
    }
  }

  UNSAFE_componentWillMount () {
    this.props.actions.fetchTemplateTypes()
  }

  componentWillUnmount () {
    this.setState({ templateTypeId: null })
    this.props.actions.resetTemplate()
  }

  render () {
    const {
      t, templateList, pagesCount, filter, templatesCount = 0,
      filter: { page },
      combos: { templateTypesCombo },
      actions: { fetchTemplateList, setActiveTemplate, duplicateTemplate, deleteTemplate, openAddTemplateModal, openEditTemplateModal }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'templatesPage' })
    const tKey = 'TEMPLATES.'
    const setActiveTooltip = (<Tooltip id="setActiveTooltip">{t(`${tKey}TABLE.SET_ACTIVE`)}</Tooltip>)
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}TABLE.EDIT`)}</Tooltip>)
    const duplicateTooltip = (<Tooltip id="duplicateTooltip">{t(`${tKey}TABLE.DUPLICATE`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}TABLE.DELETE`)}</Tooltip>)
    return (

      <div id='templatesAdmin' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            {(templateList && templateList.length > 0) || this.state.templateTypeId ? (
              <Button
                className="_Btn new"
                onClick={() => openAddTemplateModal(this.state.templateTypeId) }>
                <i className='iDocIcon-add-plus'></i>{t(`${tKey}TABLE.ADD`)}
              </Button>
            ) : (
              <></>
            )}
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="templateTypeId"
                name='templateTypeId'
                placeholder={t(`${tKey}TEMPLATE_TYPE`)}
                controlLabel={t(`${tKey}TEMPLATE_TYPE`)}
                onInputChange={this.onTemplateTypeChange.bind(this)}
                options={templateTypesCombo}
                valueKey="id"
                labelKey="value"
              />
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(templateList && templateList.length > 0) || this.state.templateTypeId ? [
                <div className="table-wrapper" key="table-wrapper">
                  <Table className="editable-table" hover responsive>
                    <thead>
                      <tr>
                        <th>{t(`${tKey}TABLE.DESCRIPTION`)}</th>
                        <th>{t(`${tKey}TABLE.LAST_MODIFICATION_DATE`)}</th>
                        <th className='actions'>{t(`${tKey}TABLE.ACTIVE`)}</th>
                        <th className='actions'>{t(`${tKey}TABLE.ACTIONS`)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {templateList && templateList.length > 0 && templateList.map((template, idx) => {
                        return (
                          <tr key={template.versionId}>
                            <td>{template.versionName}</td>
                            <td>{template.lastUpdateDate}</td>
                            <td className='actions'>
                              <div>
                                {template.isCurrent && (<i className="iDocIcon-favorite"/>)}
                                {!template.isCurrent && (
                                  <OverlayTrigger placement="left" overlay={setActiveTooltip}>
                                    <a onClick={() => setActiveTemplate(template.versionId)}>
                                      <i className="iDocIcon-unfavorite"/>
                                    </a>
                                  </OverlayTrigger>
                                )}
                              </div>
                            </td>
                            <td className='actions'>
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openEditTemplateModal(template.versionId)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={duplicateTooltip}>
                                  <a className='_Btn accent stk o-icn ' onClick={() => duplicateTemplate(template.versionId)}>
                                    <i className="iDocIcon-copy-clone" />
                                  </a>
                                </OverlayTrigger>
                                {!template.isCurrent && (
                                  <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                    <a className='_Btn cancel stk o-icn ' onClick={() => deleteTemplate(template.versionId)}>
                                      <i className="iDocIcon-delete-forever" />
                                    </a>
                                  </OverlayTrigger>
                                )}
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>,
                <div className="section-users-footer" key="section-users-footer">
                  <nav key={1} className="text-center">
                    <IDocCarPagination
                      id="btn_pag_sales"
                      page={page}
                      pagesCount={pagesCount}
                      totalRows={templatesCount}
                      onSelectAction={(value) => fetchTemplateList({ ...filter, page: value })}
                    />
                  </nav>
                </div>
              ] : (
                <p className="no_results" >{t(`${tKey}TABLE.TEMPLATE_TYPE_REQUIRED`)}</p>
              )}
            </div>
          </div>
        </div>
        <TemplatesModalPage />
      </div>
    )
  }
}

export default reduxForm({
  form: 'templatesSearch'
})(Templates)
